import { render, staticRenderFns } from "./homework-item.vue?vue&type=template&id=cdd1a726&scoped=true"
import script from "./homework-item.vue?vue&type=script&lang=js"
export * from "./homework-item.vue?vue&type=script&lang=js"
import style0 from "./homework-item.vue?vue&type=style&index=0&id=cdd1a726&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd1a726",
  null
  
)

export default component.exports